var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox241(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1475_6132)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1475_6132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56927 10.6668C6.64356 10.7407 6.73195 10.7993 6.82934 10.8394C6.92673 10.8794 7.03119 10.9 7.13669 10.9C7.24219 10.9 7.34665 10.8794 7.44404 10.8394C7.54142 10.7993 7.62981 10.7407 7.70411 10.6668L10.9648 7.45101C11.1153 7.30259 11.1998 7.10129 11.1998 6.89139C11.1998 6.68149 11.1153 6.4802 10.9648 6.33178C10.8143 6.18336 10.6102 6.09998 10.3974 6.09998C10.1845 6.09998 9.98042 6.18336 9.82993 6.33178L7.13669 8.99586L6.16968 8.03427C6.01919 7.88585 5.81508 7.80247 5.60226 7.80247C5.38943 7.80247 5.18533 7.88585 5.03484 8.03427C4.88435 8.18269 4.7998 8.38399 4.7998 8.59389C4.7998 8.80378 4.88435 9.00508 5.03484 9.1535L6.56927 10.6668Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1475_6132",
    x: -1.2002,
    y: 0.0999756,
    width: 18.4004,
    height: 16.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1475_6132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1475_6132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1475_6132"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox241);
export default __webpack_public_path__ + "static/media/check_box_24(1).3ada90b2d875d5a6cd1914a929df0964.svg";
export { ForwardRef as ReactComponent };